const locale = {
    placeholder: 'Sila pilih masa',
};
export default locale;
